<template>
  <div class="mainContaner full_w">
    <loading v-show="showLoading"></loading>
    <div v-if="!showLoading">
      <!--header-->
      <!--<div class="nav_bar">-->
        <!--<button class="clear_style fl nav_bar_left_item" style="width: 2rem;height: 2rem" ><img class="nav_item_btn" src="@/images/back.png" @click="$router.back(-1)" ></button>-->
        <!--<p class="clear_style fl nav_bar_search tc">收货地址</p>-->
      <!--</div>-->
      <div class="cart_content" v-if="emptyList">
        <p class="tc grey zt16" style="padding: 2rem 0">收货地址是空的，请新增收货地址</p>
      </div>
      <!--content-->
      <div class="cart_content" v-if="!emptyList">
        <!--address-->
        <div @click="selectedAddress(addressItem)" class="content_item" v-for="(addressItem,index) in postalAddressList" :key="index">
          <p class="clear_style zt16 black">{{addressItem.partyName}}<span class="address_phone">{{addressItem.contactNumber}}</span><span v-if="addressItem.isDefault == 1" class="zt12 fr address_default_tag">默认</span></p>
          <div class="clear_style zt14 grey" style="padding-bottom: 0.5rem">
            <p class="clear_style address_address1">{{addressItem.province + addressItem.city + addressItem.district + addressItem.address}}</p>
          </div>
          <div class="clear_style clear_both" style="padding: 0.5rem 0 0 0;border-top: 1px solid #E7E7E7">
            <span @click="postalAddressModify(addressItem)" class="fl zt12 grey">
              <img style="position: absolute;width: 1rem;height: 1rem" :src="addressItem.isDefault == 1?require('@/images/icon_Selected@3x.png') : require('@/images/icon_Unselected@3x.png')"/>
              <p class="clear_style" style="margin-left: 1.25rem">设为默认</p>
            </span>
            <span class="fr zt14" @click="pushEdit(addressItem)">
              <img style="width: 1.25rem;height: 1.25rem;" src="@/images/icon_edit@3x.png">
            </span>
          </div>
        </div>
      </div>

      <!--结算-->
      <div class="balance_view tc">
        <van-button ref="jiesuanBtn" color="#EB84AB" style="width: 17rem;height: 3rem" round type="primary" loading-text="新增收货地址" to="/address_add" >新增收货地址</van-button>
      </div>

    </div>
  </div>
</template>

<script>

  import Vue from 'vue';
  import { storeName,prodCatalogId } from '@/router/Constant'
  import { getPostalAddressList,postalAddressModify } from '@/router/api';
  import { setStore,getStore } from '@/utils/mUtil';
  import {Image,Button } from 'vant';
  import {Overlay,PullRefresh,Toast } from 'vant';
  import footerView from '../common/footer';
  import loading from '@/components/page/common/loading.vue';
  import refresh from '@/components/page/common/refresh.vue';

  export default {
    name: 'addressList',
    data() {
      return {
        token:"",
        fromUrl:this.$route.query.fromUrl,
        productStoreId:storeName,
        prodCatalogId:prodCatalogId,
        totalPrices:0,
        showLoading:true,
        viewIndex:0,
        viewSize:20,
        emptyList:false,
        postalAddressList:[],
        selectAction:false,
      }
    },
    components: {
      [Image.name]: Image,
      [Button.name]: Button,
      [Overlay.name]: Overlay,
      [PullRefresh.name]: PullRefresh,
      [Toast.name]: Toast,
      footerView,
      loading,
      refresh
    },
    methods:{
      async initData() {
        this.getPostalAddressList();
      },
      getPostalAddressList() {
        getPostalAddressList({externalLoginKey:getStore('externalLoginKey'),viewIndex:this.viewIndex,viewSize: this.viewSize})
          .then(res => {
            console.log("getPostalAddressList")
            console.log(JSON.stringify(res))
            if (res.postalAddressList.length == 0) {
              this.emptyList = true;
            } else {
              this.emptyList = false;
            }
            this.postalAddressList = res.postalAddressList
            setTimeout(() => {
              this.showLoading = false;
            }, 1000);
          })
          .catch(err => {
            console.log(err);
          });
      },
      postalAddressModify(item) {
        this.selectAction = true
        if (item.isDefault == 1) {
          item.isDefault = 0
        } else {
          item.isDefault = 1
        }
        postalAddressModify({externalLoginKey:getStore('externalLoginKey'),contactMechId:item.contactMechId,partyName:item.partyName,phone:item.contactNumber,province:item.stateProvinceGeoId,city: item.cityGeoId,district:item.countyGeoId,address:item.address,isDefault:item.isDefault,productStoreId: storeName})
          .then(res => {
            console.log("postalAddressModify")
            console.log(res)
            if (res._ERROR_MESSAGE_) {
              Toast(res._ERROR_MESSAGE_);
            } else {
              Toast(res._EVENT_MESSAGE_);
              this.getPostalAddressList();
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      selectedAddress(item) {
        if (this.fromUrl == "order" && this.selectAction == false) {
          console.log(item.contactMechId)
          setStore('currentAddress',item.contactMechId)
          this.selectAction = false
          this.$router.back(-1);
        }else if(this.fromUrl == "game" && this.selectAction == false){
          console.log(item)
          setStore('gameAddress',item)
          this.selectAction = false
          this.$router.back(-1);
        } else {
          this.selectAction = false
          return false
        }
      },


      pushEdit(item) {
        this.selectAction = true
        this.$router.push({path:'/address_add',query:{id:item.contactMechId,contactNumber:item.contactNumber,district:item.countyGeoId,isDefault:item.isDefault,province:item.stateProvinceGeoId,toName:item.partyName,address:item.address,city:item.cityGeoId,countyGeoId:item.countyGeoId,isEdit:true}})
      },
      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      }
    },
    mounted() {
      this.initData();
      this.resetScorllView();
    }

  }
</script>

<style lang="scss" scoped>

  .mainContaner {
    position: absolute;top: 0;
  }

  .nav_bar {
    background-color: white;padding-top: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;border-bottom: 1px solid #eaeaea;z-index: 101;
  }

  .nav_bar_left_item {
    padding-top: 0.3rem;
  }

  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }

  .nav_bar_search {
    width: 16.3rem;margin: 0 0.4rem;background-color: white;height: 2rem;line-height: 2rem;padding: 0 0.8rem
  }

  .cart_content {
    padding: 0 1rem;
    padding-bottom: 3rem;
  }

  .cart_group_item {
    padding-top: 0;
  }

  .balance_view {
    height: 4rem;width: 100%;position: fixed;bottom: 0;background-color: transparent;
  }

  .content_item {
    background-color: white;padding: 0.7rem 0.5rem;;box-shadow: 0px 1px 17px #F0F0F0;border-radius: 0.2rem;margin: 1rem 0;
  }

  .address_phone {
    margin-left: 2rem;margin-bottom: 0.3rem
  }

  .address_default_tag {
    padding: 0rem 0.5rem;background-color: #EB84AB;color: white;border-radius: 0.5rem;margin-top: 0.2rem
  }

  .address_address1 {
    width: 20rem
  }

  .address_detail_icon {
    margin-top: -1rem;width: 0.875rem;height: 0.875rem
  }

  .animate_action {
    transition:all .4s;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/order/addressList.vue